import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import {
  ButtonSkeleton,
  DoubleTextSkeleton,
  ImageSkeleton,
  InputSkeleton,
  TextSkeleton,
} from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';

export const ListLoadingItemDesktop: React.FC = () => {
  return (
    <TableContent
      direction="column"
      space={Spacing['stack.xxxs']}
      p={0}
      px={Spacing['inline.xxxs']}
      py={Spacing['stack.xxxs']}>
      <LateralBar
        backgroundColor={Color['product.rendavariavel']}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <HStack justifyContent="space-between" w="full">
        <Stack w="1/5">
          <HStack w="full" alignItems="center" space={Spacing['inline.xxxs']}>
            <ImageSkeleton />
            <DoubleTextSkeleton w="60%" />
          </HStack>
        </Stack>
        <Stack w="1/5">
          <VStack space={Spacing['stack.quarck']} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Ultimo preço
            </UI.Text>
            <DoubleTextSkeleton />
          </VStack>
        </Stack>
        <Stack w="1/5">
          <VStack space={Spacing['stack.quarck']} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Melhor Compra
            </UI.Text>
            <TextSkeleton />
          </VStack>
        </Stack>
        <Stack w="1/5">
          <VStack space={Spacing['stack.quarck']} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Melhor Venda
            </UI.Text>
            <TextSkeleton />
          </VStack>
        </Stack>
        <Stack w="1/5">
          <VStack space={Spacing['stack.quarck']} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Fechamento
            </UI.Text>
            <TextSkeleton />
          </VStack>
        </Stack>
      </HStack>
      <HStack justifyContent="space-between" w="full" alignItems="center">
        <Stack w="1/5">
          <VStack space={Spacing['stack.quarck']} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Tipo da ordem
            </UI.Text>
            <Stack pr={Spacing['inline.xxxs']}>
              <InputSkeleton />
            </Stack>
          </VStack>
        </Stack>
        <Stack w="1/5">
          <VStack space={Spacing['stack.quarck']} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Quantidade
            </UI.Text>
            <Stack pr={Spacing['inline.xxxs']}>
              <InputSkeleton />
            </Stack>
          </VStack>
        </Stack>
        <Stack w="1/5">
          <VStack space={Spacing['stack.quarck']} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Preço por ativo
            </UI.Text>
            <Stack pr={Spacing['inline.xxxs']}>
              <InputSkeleton />
            </Stack>
          </VStack>
        </Stack>
        <Stack w="1/5">
          <VStack space={Spacing['stack.quarck']} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Total estimado
            </UI.Text>
            <TextSkeleton />
          </VStack>
        </Stack>
        <HStack w="1/5" space="inline.nano">
          <Stack w="1/2">
            <ButtonSkeleton />
          </Stack>
          <Stack w="1/2">
            <ButtonSkeleton />
          </Stack>
        </HStack>
      </HStack>
    </TableContent>
  );
};
